module.exports = __webpack_public_path__ + "img/148.a7a3e39d.png";